import { useQuery } from "@tanstack/react-query";
import { useApi } from "./api";

export function useMorningFocus(enabled = true) {
  const api = useApi();
  return useQuery({
    queryKey: ["rhythm-morning"],
    queryFn: () => api.get<{ focus: string | null }>("/rhythm/morning"),
    enabled,
    staleTime: 5 * 60_000,
  });
}

interface MiddayInsight {
  id: string;
  title: string;
  url: string;
  summary: string;
  source_name: string;
}
interface MiddayOpportunity {
  id: string;
  title: string;
  deadline_at: number | null;
  geo: string | null;
}
interface MiddayContinuity {
  message: string;
  link: string;
}

export interface MiddayPayload {
  insight: MiddayInsight | null;
  opportunity: MiddayOpportunity | null;
  prompt: string;
  continuity: MiddayContinuity | null;
}

export function useMidday(enabled = true) {
  const api = useApi();
  return useQuery({
    queryKey: ["rhythm-midday"],
    queryFn: () => api.get<MiddayPayload>("/rhythm/midday"),
    enabled,
    staleTime: 15 * 60_000,
  });
}

export interface WeeklyPayload {
  window_days: number;
  generated_at: number;
  narratives: Array<{
    id: string;
    title: string;
    url: string;
    published_at: number | null;
    source_name: string;
    summary: string;
    trend_score: number;
    relevance_score: number;
  }>;
  opportunities_to_revisit: Array<{
    id: string;
    title: string;
    organization: string | null;
    deadline_at: number | null;
    geo: string | null;
    saved_at: number;
  }>;
  circles: Array<{
    id: string;
    slug: string;
    name: string;
    kind: string;
    role: string;
    prompt: string | null;
  }>;
  themes: string[];
  reflections: { total: number; top_category: string | null };
}

export function useWeeklyReset() {
  const api = useApi();
  return useQuery({
    queryKey: ["rhythm-weekly"],
    queryFn: () => api.get<WeeklyPayload>("/rhythm/weekly"),
    staleTime: 30 * 60_000,
  });
}
